import axios from 'axios';
import { API_BASE_URL } from '../config/api';
import authService from './authService';

const tsApi = axios.create({
  baseURL: `${API_BASE_URL}/timesheets`,
  headers: { 'Content-Type': 'application/json' },
});

tsApi.interceptors.request.use((config) => {
  const token = authService.getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const getTimesheets = async (params = {}) => tsApi.get('', { params });
export const getTimesheetById = async (id) => tsApi.get(`/${id}`);
export const getTimesheetsByEmployee = async (employeeId, startDate, endDate) =>
  tsApi.get(`/employee/${employeeId}`, { params: { startDate, endDate } });
export const getTimesheetsByDate = async (date) => tsApi.get(`/date/${date}`);
export const createTimesheet = async (data) => tsApi.post('', data);
export const updateTimesheet = async (id, data) => tsApi.put(`/${id}`, data);
export const approveTimesheet = async (id) => tsApi.put(`/${id}/approve`);
export const rejectTimesheet = async (id, reason) => tsApi.put(`/${id}/reject`, { reason });
export const bulkApproveTimesheets = async (ids) => tsApi.post('/bulk-approve', { ids });
export const deleteTimesheet = async (id) => tsApi.delete(`/${id}`);
export const getMonthlySummary = async (employeeId, year, month) =>
  tsApi.get(`/employee/${employeeId}/monthly-summary`, { params: { year, month } });
export const getAbsences = async (startDate, endDate) =>
  tsApi.get('/absences', { params: { startDate, endDate } });
export const getWeeklySummary = async (employeeId, date) =>
  tsApi.get(`/employee/${employeeId}/weekly-summary`, { params: { date } });
export const getOvertimeBalance = async (employeeId, year, month) =>
  tsApi.get(`/employee/${employeeId}/overtime-balance`, { params: { year, month } });
export const setOvertimeBalance = async (employeeId, year, month, balanceHours) =>
  tsApi.put(`/employee/${employeeId}/overtime-balance`, { balanceHours }, { params: { year, month } });

export default {
  getTimesheets,
  getTimesheetById,
  getTimesheetsByEmployee,
  getTimesheetsByDate,
  createTimesheet,
  updateTimesheet,
  approveTimesheet,
  rejectTimesheet,
  bulkApproveTimesheets,
  deleteTimesheet,
  getMonthlySummary,
  getAbsences,
  getWeeklySummary,
  getOvertimeBalance,
  setOvertimeBalance,
};

